export const ACTION_FLAGS = {
  CANCREATE: 1,
  CANVIEW: 2,
  CANEDIT: 4,
  CANDELETE: 8,
};
